import React from "react";

import TextBlock from "./TextBlock";
import HeadingBlock from "./HeadingBlock";
import ImageBlock from "./ImageBlock";
import ProgramCodeBlock from "./ProgramCodeBlock";
import SingleChoiceBlock from "./SingleChoiceBlock";
import ListBlock from "./ListBlock";
import MultipleChoiceBlock from "./MultipleChoiceBlock";
import PlaceholderCodeBlock from "./PlaceholderCodeBlock";

const BlockRenderer = ({block, onComplete}) => {

    switch (block.type) {

        case "text":
            return (
                <TextBlock
                    config={block.config}
                />
            );

        case "heading":
            return (
                <HeadingBlock
                    config={block.config}
                />
            );

        case "image":
            return (
                <ImageBlock
                    config={block.config}
                />
            );

        case "list":
            return (
                <ListBlock
                    config={block.config}
                />
            );

        case "code":
            return (
                <ProgramCodeBlock
                    config={block.config}
                />
            );

        case "question_single_choice":
            return (
                <SingleChoiceBlock
                    config={block.config}
                    onComplete={onComplete}
                />
            );

        case "question_multiple_choice":
            return (
                <MultipleChoiceBlock
                    config={block.config}
                    onComplete={onComplete}
                />
            );

        case "placeholder_code":
            return (
                <PlaceholderCodeBlock
                    config={block.config}
                />
            );

        default:
            console.warn(`Unknown lesson block type: ${block.type}`);
            return null;
    }
};

export default BlockRenderer;